import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { styled } from "@mui/material";

const SvgIconStyled = styled(SvgIcon)`
  pointer-events: auto !important;
  user-select: auto !important;
`;

export const IconCheckMark = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width={"121"}
      height={"121"}
      viewBox="0 0 121 121"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.5 0C93.9132 0 121 27.0868 121 60.5C121 93.9132 93.9132 121 60.5 121C27.0868 121 0 93.9132 0 60.5C0 27.0868 27.0868 0 60.5 0ZM56.5341 73.343L36.9706 53.7794L31.0919 59.6581L56.896 85.4622L90.0779 48.1371L83.8596 42.6129L56.5341 73.343Z"
        fill="currentColor"
      />
    </SvgIconStyled>
  );
};

export const IconClose = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} viewBox="0 0 21 21">
      <path
        d="M18.067 2.0057L2.00737 18.0654M18.0865 18.0865L2 2"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconStyled>
  );
};

export const IconLoader = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} viewBox="0 0 1460 1600">
      <path
        stroke="#D9D9D9"
        d="M156 1576L0 1600L356 696L724 0L1148 792L1460 1600H1340L1220 1520L1180 1396L1012 996L764 456H688L456 956L244 1520L156 1576Z"
      />
    </SvgIconStyled>
  );
};

export const IconLight = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} width="50" height="26" viewBox="0 0 50 26">
      <path
        d="M35.9263 24.4797C35.9263 18.1515 31.1448 13.0215 25.2464 13.0215C19.348 13.0215 14.5664 18.1515 14.5664 24.4797"
        stroke="currentColor"
        fill={"none"}
        strokeWidth="2"
      />
      <path d="M24.7578 0V9.89572" stroke="currentColor" strokeWidth="2" />
      <path
        d="M41.9062 5.72949L35.9225 13.2602"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M7.76953 6.77148L14.2916 13.7688"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M9.22266 24.4785L-0.000948668 24.4785"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M50 24.4785L0.5 24.4785" stroke="currentColor" strokeWidth="2" />
    </SvgIconStyled>
  );
};

export const IconSun = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6846 11.1357C22.1233 11.1358 25.0879 14.1597 25.0879 18.1152C25.0877 22.0705 22.1232 25.0937 18.6846 25.0938C15.2459 25.0938 12.2815 22.0706 12.2812 18.1152C12.2812 14.1597 15.2458 11.1357 18.6846 11.1357Z"
        stroke="currentColor"
        fill={"none"}
        strokeWidth="2"
      />
      <path d="M18.3203 0V7.32284" stroke="currentColor" strokeWidth="2" />
      <path
        d="M18.3203 29.6777V37.0006"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10.8945 26.5928L6.46653 32.1655"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M31.0117 4.24023L26.5837 9.81296"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M26.582 26.5928L31.4084 31.7708"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M5.75 5.01074L10.5763 10.1888"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M6.82422 18.1143L-0.00125906 18.1143"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M37 18.1143L30.1745 18.1143"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIconStyled>
  );
};

export const IconMoon = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41113 2.67285C11.3411 1.07803 14.5369 0.332189 17.8955 0.530273V0.53125C18.4623 0.571318 18.8789 0.883942 19.0225 1.2793C19.1864 1.73145 19.0974 2.17762 18.7637 2.48438C15.7762 5.23022 14.4707 9.14437 15.2432 12.9561L15.3242 13.3252C16.727 19.1807 22.6617 23.1037 29.0664 22.5254L29.0674 22.5264C29.6385 22.486 30.1094 22.73 30.3311 23.1035C30.5746 23.514 30.554 23.9392 30.2725 24.2627L30.2656 24.2705L30.2588 24.2793C27.8809 27.2594 24.4163 29.3532 20.4541 30.1514H20.4502C19.2618 30.3996 18.0695 30.5 16.9268 30.5C13.3405 30.5 9.8175 29.4512 6.95215 27.4141L6.94824 27.4111C3.22711 24.8099 0.937893 20.9117 0.553711 16.6201L0.522461 16.2041C0.200525 10.8284 3.31686 5.51346 8.41211 2.67383L8.41113 2.67285ZM16.1797 1.83984C13.7629 1.94562 11.3999 2.58093 9.20996 3.79883C4.74006 6.26372 1.92313 10.8812 2.0166 15.6484L2.03516 16.1094C2.26768 20.2179 4.41591 23.9428 7.87988 26.3838C11.3439 28.8246 15.8358 29.7206 20.0918 28.875C23.1478 28.2914 25.8601 26.807 27.9385 24.6846L28.7627 23.8438L27.585 23.835C20.9834 23.785 15.2341 19.51 13.7871 13.5547C12.8775 9.71827 13.8916 5.73067 16.5771 2.66992L17.3496 1.78906L16.1797 1.83984Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIconStyled>
  );
};

const ArrowBase = (props?: SvgIconProps) => (
  <SvgIconStyled {...props} viewBox="0 0 24 24">
    <path
      d="M15 4 L7 12 L15 20"
      stroke="currentColor"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIconStyled>
);

export const IconArrowLeft2 = (props?: SvgIconProps) => (
  <ArrowBase {...props} />
);

export const IconArrowRight2 = (props?: SvgIconProps) => (
  <ArrowBase {...props} sx={{ transform: "scaleX(-1)" }} />
);

export const IconArrowLeft = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} width="23" height="51" viewBox="0 0 23 51">
      <path
        opacity="0.5"
        d="M20.8984 49.9326L1.89844 24.8493L20.8984 0.932618"
        stroke="currentColor"
        strokeWidth="3"
        fill={"none"}
      />
    </SvgIconStyled>
  );
};

export const IconArrowRight = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} width="14" height="28" viewBox="0 0 14 28">
      <path
        fill={"none"}
        d="M0.800823 0.601562L10.8008 13.8834L0.800781 26.5475"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIconStyled>
  );
};

export const IconArrowSharpLeft = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
    >
      <path
        d="M6.48436 6.92187L0.984375 3.92187L6.48438 0.421875"
        stroke="currentColor"
        fill={"none"}
      />
    </SvgIconStyled>
  );
};

export const IconArrowSharpRight = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled {...props} viewBox="0 0 7 8" fill="none">
      <path
        d="M0.269548 0.438477L5.76953 3.43848L0.26953 6.93848"
        stroke="currentColor"
        fill="none"
      />
    </SvgIconStyled>
  );
};

export const IconRectangle = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.879133"
        y="12.625"
        width="16.6107"
        height="16.6107"
        rx="1.5"
        transform="rotate(-45 0.879133 12.625)"
        strokeWidth="3"
      />
    </SvgIconStyled>
  );
};

export const IconRotate = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="195"
      height="195"
      viewBox="0 0 195 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M82.3839 15.022C77.5988 10.3183 69.9595 10.3838 65.3362 15.1682L14.6319 66.7501C9.92814 71.5352 9.99368 79.1745 14.7781 83.7978L112.265 179.626C117.05 184.33 124.689 184.264 129.312 179.48L180.017 127.898C184.72 123.113 184.655 115.473 179.87 110.85L82.3839 15.022ZM114.957 165.369L28.9872 80.8612C25.8241 77.752 25.7807 72.6859 28.8899 69.5229L68.3532 29.3766C71.4625 26.2136 76.5285 26.1701 79.6916 29.2794L165.742 113.866C168.905 116.976 168.949 122.042 165.84 125.205L126.376 165.351C123.266 168.434 118.12 168.478 114.957 165.369ZM141.705 11.6984C129.023 5.13237 113.06 0.444135 94.97 1.00141C93.5225 1.01383 92.8944 2.78845 93.8683 3.82555L122.092 31.5695L132.696 20.7827C157.644 32.3099 175.938 55.5551 180.602 83.5816C181.112 86.8744 184.187 89.0998 187.56 88.5079C190.853 87.9971 193.077 84.8417 192.486 81.5495C187.399 51.0337 168.201 25.4641 141.705 11.6984ZM72.5568 163.159L61.9536 173.946C37.005 162.418 18.7112 139.173 14.0477 111.147C13.5369 107.854 10.4619 105.629 7.08932 106.22C3.7965 106.731 1.57182 109.887 2.163 113.179C7.25064 143.775 26.449 169.345 52.9447 183.11C65.627 189.676 81.5903 194.365 99.6799 193.807C101.127 193.795 101.755 192.02 100.782 190.983L72.5568 163.159Z"
        fill="currentColor"
      />
    </SvgIconStyled>
  );
};

export const IconMoreVert = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="5" r="1.6" fill="currentColor" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" />
      <circle cx="12" cy="19" r="1.6" fill="currentColor" />
    </SvgIconStyled>
  );
};

export const IconLogoMark = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="250"
      height="109"
      viewBox="0 0 250 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M224.629 31.2043H216.736C219.263 36.1484 221.79 41.2951 224.317 46.5813C225.164 48.3527 223.867 50.4019 221.9 50.4019H180.966C179.963 50.4019 179.023 49.8389 178.586 48.9011L172.822 37.2076C171.005 33.518 167.246 31.2043 163.175 31.2043H155.406C155.406 31.2043 161.733 43.4596 166.494 54.2152C168.937 59.8423 174.575 63.5319 180.652 63.5319H222.373C225.442 63.5319 228.324 62.6559 230.831 61.0301C232.835 65.6575 234.777 70.2849 236.531 74.7861C237.659 77.5997 235.592 80.6013 232.585 80.6013H177.457L179.211 85.4156C181.028 90.4179 185.789 93.7325 191.113 93.7325H232.052C244.844 93.7325 253.511 80.753 248.61 68.9588C244.082 58.0649 238.964 46.6966 234.275 37.2683C232.521 33.5787 228.763 31.2031 224.628 31.2031L224.629 31.2043Z"
        fill="currentColor"
      />
      <path
        d="M129.167 0C108.291 34.4629 91.4281 70.5297 79.6523 109H86.0763C90.8945 109 95.1768 105.795 96.515 101.252C103.206 81.4831 117.124 47.7688 126.224 31.2053H132.112C141.748 49.3715 154.594 79.3453 161.554 101.252C163.16 105.793 167.442 109 172.26 109H178.684C166.637 70.7966 150.312 35.2648 129.167 0Z"
        fill="currentColor"
      />
      <path
        d="M103.044 31.2266H35.3298C20.6089 31.2266 14.9884 53.4002 29.7093 60.0793L66.3775 76.6428C68.2505 77.4448 67.7157 80.6502 65.3066 80.6502H12.3118C7.76221 80.6502 3.7474 83.3219 2.14172 87.5962L0 93.7414H65.3066C81.6332 93.7414 86.4503 71.3008 71.7305 64.6218L35.3298 48.3251C33.4567 47.5232 33.9916 44.3177 36.4007 44.3177H89.9303C93.9451 44.3177 97.6925 42.1799 99.2982 38.4407L103.046 31.2278L103.044 31.2266Z"
        fill="currentColor"
      />
      <path
        d="M103.044 31.2266H35.3298C20.6089 31.2266 14.9884 53.4002 29.7093 60.0793L66.3775 76.6428C68.2505 77.4448 67.7157 80.6502 65.3066 80.6502H12.3118C7.76221 80.6502 3.7474 83.3219 2.14172 87.5962L0 93.7414H65.3066C81.6332 93.7414 86.4503 71.3008 71.7305 64.6218L35.3298 48.3251C33.4567 47.5232 33.9916 44.3177 36.4007 44.3177H89.9303C93.9451 44.3177 97.6925 42.1799 99.2982 38.4407L103.046 31.2278L103.044 31.2266Z"
        fill="currentColor"
      />
    </SvgIconStyled>
  );
};

export const LOGO_MARK_VIEWBOX = "0 0 639.06 236.93";

export const LogoMarkPaths = () => (
  <>
      <path d="M178.66,138.34h-91.75c-5.1,0-8.5-5.29-6.37-9.93l5.35-11.62c1.43-3.1,5.39-6.56,8.81-6.56h129.11c9.28,0,17.77-5.23,21.92-13.53,3.7-7.42,7.43-14.64,11.18-21.68H92.97c-16.12,0-30.76,9.38-37.5,24.03,0,0-10.4,22.17-11.62,24.83-10.73,23.19,6.26,49.69,31.81,49.69h92.64c4.9,0,8.29,4.92,6.54,9.5l-4.66,12.99c-1.3,3.4-4.55,5.64-8.18,5.64H29.24c-10.55,0-19.91,6.76-23.26,16.76-2.1,6.27-4.09,12.43-5.98,18.45h162.85c17.73,0,33.62-10.95,39.94-27.53,0,0,7.29-20.11,8.63-23.69,8.67-22.88-8.32-47.35-32.79-47.35h.02Z" />
      <path d="M326.74,0c48.84,73.27,85.83,152.82,112.34,236.9h-11.86c-16.75,0-31.4-10.47-36.98-26.17-13.61-40.82-41.87-105.72-58.96-135.72h-9.07c-17.1,30.01-45.35,94.91-58.96,135.72-5.59,15.7-20.23,26.17-36.98,26.17h-11.86c26.51-84.08,63.5-163.64,112.34-236.9h-.01Z" />
      <path d="M477.29,236.91h126.21c24.58,0,42.23-24.36,33.13-47.02-5.05-12.59-20.16-51.06-31.37-74.57-4.01-8.82-9.23-18.68-13.51-26.95-4.28-8.29-12.56-13.36-21.65-13.36h-25.91c11.75,22.18,20.18,39.78,27.67,55.8,1.6,3.48-1.07,7.49-4.81,7.49h-93.16c-3.48,0-6.68-2.13-8.02-5.34-6.41-13.36-14.57-31.49-21.79-44.59-4.01-8.29-12.56-13.36-21.64-13.36h-25.91c16.29,29.65,23.92,48.05,36.49,75.57,5.88,13.89,19.5,22.98,34.46,22.98h116.4c3.74,0,6.94,2.13,8.29,5.61,2.13,5.61,3.6,10.19,5.46,15.8,1.33,3.21-1.33,6.94-4.81,6.94h-145.18c2.4,6.14,4.28,12.28,6.41,18.44,3.21,9.88,12.83,16.56,23.25,16.56h0Z" />
  </>
);

// Full "SAY CARBON YACHTS" wordmark
export const LOGO_WORDMARK_VIEWBOX = "0 0 639.1 312.5";

// Wordmark paths without a per-path fill, so the fill can be driven by the parent
// (solid in the header, progress-masked in AnimatedLogo).
export const LogoWordmarkPaths = () => (
  <>
      <LogoMarkPaths />
      <path d="M14,306.9c-4.4-3.7-6.6-8.4-6.6-13.9s2.2-10.1,6.6-13.8c4.4-3.7,9.8-5.6,16.4-5.6s10.2,1.2,14,3.6,6.2,5.2,7.4,8.5l-8.4,1.8c-.8-2-2.3-3.6-4.6-5-2.3-1.4-5-2-8.2-2s-7.7,1.2-10.3,3.6c-2.6,2.4-3.9,5.4-3.9,8.8s1.3,6.5,4,9c2.6,2.5,6.1,3.7,10.2,3.7s5.9-.7,8.2-2c2.3-1.3,3.8-3,4.6-4.9l8.4,1.8c-1.1,3.3-3.5,6.1-7.3,8.5s-8.4,3.6-13.8,3.6-12.1-1.9-16.5-5.6h0Z" />
      <path d="M90.7,303.6h-19.8l-3.6,8.1h-8.9l16.8-37.4h11.2l16.9,37.4h-9l-3.6-8.1ZM87.8,297.1l-7.1-15.8-7,15.8h14.1Z" />
      <path d="M131.2,298.6h-9.4v13.1h-8.6v-37.4h21.4c4.5,0,8.2,1.2,10.9,3.7,2.8,2.5,4.2,5.3,4.2,8.5s-.8,4.8-2.5,6.9c-1.7,2.1-4,3.6-7.1,4.5l10.9,13.8h-9.9l-10-13.1ZM121.9,292.2h12.3c2.2,0,3.9-.6,5.3-1.6,1.4-1.1,2-2.5,2-4.1s-.7-2.8-2-4c-1.3-1.1-3-1.7-5-1.7h-12.6v11.3h0Z" />
      <path d="M197.8,295.7c1.2,1.6,1.9,3.4,1.9,5.4,0,3.2-1.3,5.8-4,7.7s-6.3,2.9-11,2.9h-22.2v-37.4h21c4.3,0,7.8.9,10.5,2.8,2.7,1.9,4,4.3,4,7.2,0,3.5-1.8,6.1-5.5,7.8,2.2.9,4,2.1,5.2,3.6h0ZM171,280.6v9.2h12.7c1.8,0,3.2-.4,4.3-1.4,1.1-.9,1.6-2,1.6-3.3,0-1.3-.6-2.4-1.7-3.3-1.1-.9-2.6-1.3-4.4-1.2h-12.5ZM189.4,303.9c1.2-.9,1.8-2.1,1.8-3.5s-.6-2.5-1.7-3.4c-1.2-.9-2.7-1.4-4.7-1.4h-13.8v9.7h13.7c2,0,3.5-.5,4.7-1.4h0Z" />
      <path d="M216.2,306.9c-4.4-3.7-6.6-8.4-6.6-13.9s2.2-10.1,6.6-13.8c4.4-3.7,9.9-5.6,16.5-5.6s12.1,1.8,16.5,5.6c4.4,3.7,6.6,8.3,6.6,13.8s-2.2,10.2-6.6,13.9c-4.4,3.7-9.9,5.6-16.5,5.6s-12.1-1.9-16.5-5.6ZM243.2,302c2.7-2.4,4-5.5,4-9.1s-1.3-6.6-4-9c-2.7-2.4-6.1-3.6-10.4-3.6s-7.7,1.2-10.4,3.6c-2.7,2.4-4,5.4-4,9s1.3,6.7,4,9.1c2.7,2.4,6.1,3.6,10.4,3.6s7.7-1.2,10.4-3.6Z" />
      <path d="M305.9,274.3v37.4h-7.1l-22.1-24.3v24.3h-8.6v-37.4h7.1l22.1,24.3v-24.3h8.6Z" />
      <path d="M387.9,274.3l-16.6,23.7v13.7h-8.7v-13.7l-16.7-23.7h9.8l11.4,16.6,11.3-16.6h9.7,0Z" />
      <path d="M421,303.6h-19.8l-3.6,8.1h-8.9l16.8-37.4h11.2l16.9,37.4h-9l-3.6-8.1ZM418.2,297.1l-7.1-15.8-7,15.8h14.1Z" />
      <path d="M446.1,306.9c-4.4-3.7-6.6-8.4-6.6-13.9s2.2-10.1,6.6-13.8c4.4-3.7,9.8-5.6,16.4-5.6s10.2,1.2,14,3.6c3.8,2.4,6.2,5.2,7.4,8.5l-8.4,1.8c-.8-2-2.3-3.6-4.6-5-2.3-1.4-5-2-8.2-2s-7.7,1.2-10.3,3.6c-2.6,2.4-3.9,5.4-3.9,8.8s1.3,6.5,4,9c2.6,2.5,6.1,3.7,10.2,3.7s5.9-.7,8.2-2c2.3-1.3,3.8-3,4.6-4.9l8.4,1.8c-1.1,3.3-3.5,6.1-7.3,8.5-3.8,2.4-8.4,3.6-13.8,3.6s-12.1-1.9-16.5-5.6h0Z" />
      <path d="M533,274.3v37.4h-8.7v-15.7h-20.1v15.7h-8.6v-37.4h8.6v15.1h20.1v-15.1h8.7Z" />
      <path d="M579.9,280.9h-14.8v30.8h-8.6v-30.8h-14.8v-6.6h38.1v6.6h0Z" />
      <path d="M591.2,309.2c-3.6-2.2-6-4.9-7.4-8.1l8.3-2.1c.9,2.1,2.5,3.8,4.7,5,2.2,1.3,4.8,1.9,7.9,1.9s4.5-.5,6-1.4c1.6-.9,2.3-2,2.3-3.3s-.4-1.8-1.3-2.6c-.9-.7-2.4-1.4-4.5-1.9l-11.2-3c-3.1-.8-5.5-2-7.3-3.6-1.8-1.6-2.7-3.6-2.6-5.9,0-3,1.4-5.5,4.5-7.6,3-2.1,6.8-3.1,11.3-3.1s8.5.9,11.9,2.8c3.4,1.8,5.7,4.1,7,6.8l-8,2c-.9-1.5-2.4-2.8-4.3-3.7-1.9-.9-4.1-1.4-6.6-1.4s-3.8.4-5.1,1.2-2,1.7-2,2.9c0,1.6,1.4,2.8,4.2,3.5l10.9,3c3.8,1,6.8,2.2,8.8,3.8,2,1.5,3,3.7,3,6.5s-1.6,6-4.9,8.3c-3.3,2.2-7.5,3.4-12.7,3.4s-9.4-1.1-13-3.3h0Z" />
  </>
);

export const IconLogo = (props?: SvgIconProps) => (
  <SvgIconStyled
    {...props}
    width="639"
    height="237"
    viewBox={LOGO_MARK_VIEWBOX}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <LogoMarkPaths />
  </SvgIconStyled>
);

export const IconZoomOut = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="61"
      height="57"
      viewBox="0 0 61 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M59.9561 52.6663V24C59.9561 22.3431 58.613 21 56.9561 21H23.6562C21.9994 21 20.6562 22.3431 20.6562 24V52.6663C20.6562 54.3231 21.9994 55.6663 23.6563 55.6663H56.9561C58.613 55.6663 59.9561 54.3231 59.9561 52.6663Z"
          fill="currentColor"
        />
        <path
          d="M5.71473 4.3006C5.32845 3.90586 4.69533 3.899 4.3006 4.28527C3.90586 4.67155 3.899 5.30467 4.28527 5.69941L5 5L5.71473 4.3006ZM20.6562 20.9992L17.7887 9.81393L9.53573 17.89L20.6562 20.9992ZM59.9561 24H58.9561V52.6663H59.9561H60.9561V24H59.9561ZM56.9561 55.6663V54.6663H23.6563V55.6663V56.6663H56.9561V55.6663ZM20.6562 52.6663H21.6562V24H20.6562H19.6562V52.6663H20.6562ZM23.6562 21V22H56.9561V21V20H23.6562V21ZM20.6562 24H21.6562C21.6562 22.8954 22.5517 22 23.6562 22V21V20C21.4471 20 19.6562 21.7909 19.6562 24H20.6562ZM23.6563 55.6663V54.6663C22.5517 54.6663 21.6562 53.7708 21.6562 52.6663H20.6562H19.6562C19.6562 54.8754 21.4471 56.6663 23.6563 56.6663V55.6663ZM59.9561 52.6663H58.9561C58.9561 53.7708 58.0607 54.6663 56.9561 54.6663V55.6663V56.6663C59.1652 56.6663 60.9561 54.8754 60.9561 52.6663H59.9561ZM59.9561 24H60.9561C60.9561 21.7909 59.1652 20 56.9561 20V21V22C58.0607 22 58.9561 22.8954 58.9561 24H59.9561ZM45.2123 3H44.2123V36.3329H45.2123H46.2123V3H45.2123ZM43.2123 38.3329V37.3329H3V38.3329V39.3329H43.2123V38.3329ZM1 36.3329H2V3H1H0V36.3329H1ZM3 1V2H43.2123V1V0H3V1ZM1 3H2C2 2.44772 2.44772 2 3 2V1V0C1.34315 0 0 1.34315 0 3H1ZM3 38.3329V37.3329C2.44772 37.3329 2 36.8852 2 36.3329H1H0C0 37.9898 1.34315 39.3329 3 39.3329V38.3329ZM45.2123 36.3329H44.2123C44.2123 36.8852 43.7646 37.3329 43.2123 37.3329V38.3329V39.3329C44.8692 39.3329 46.2123 37.9898 46.2123 36.3329H45.2123ZM45.2123 3H46.2123C46.2123 1.34314 44.8692 0 43.2123 0V1V2C43.7646 2 44.2123 2.44772 44.2123 3H45.2123ZM5 5L4.28527 5.69941L13.6469 15.2661L14.3616 14.5667L15.0763 13.8673L5.71473 4.3006L5 5Z"
          fill="currentColor"
        />
      </g>
    </SvgIconStyled>
  );
};

export const IconZoomIn = (props?: SvgIconProps) => {
  return (
    <SvgIconStyled
      {...props}
      width="61"
      height="57"
      viewBox="0 0 61 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M59.9561 52.6663V24C59.9561 22.3431 58.613 21 56.9561 21H23.6562C21.9994 21 20.6562 22.3431 20.6562 24V52.6663C20.6562 54.3231 21.9994 55.6663 23.6563 55.6663H56.9561C58.613 55.6663 59.9561 54.3231 59.9561 52.6663Z"
          fill="currentColor"
        />
        <path
          d="M19.9526 20.7105C20.345 21.0992 20.9782 21.0961 21.3668 20.7037C21.7554 20.3112 21.7523 19.6781 21.3599 19.2895L20.6562 20L19.9526 20.7105ZM4.5 4L7.54275 15.1389L15.6679 6.93435L4.5 4ZM59.9561 24H58.9561V52.6663H59.9561H60.9561V24H59.9561ZM56.9561 55.6663V54.6663H23.6563V55.6663V56.6663H56.9561V55.6663ZM20.6562 52.6663H21.6562V24H20.6562H19.6562V52.6663H20.6562ZM23.6562 21V22H56.9561V21V20H23.6562V21ZM20.6562 24H21.6562C21.6562 22.8954 22.5517 22 23.6562 22V21V20C21.4471 20 19.6562 21.7909 19.6562 24H20.6562ZM23.6563 55.6663V54.6663C22.5517 54.6663 21.6562 53.7708 21.6562 52.6663H20.6562H19.6562C19.6562 54.8754 21.4471 56.6663 23.6563 56.6663V55.6663ZM59.9561 52.6663H58.9561C58.9561 53.7708 58.0607 54.6663 56.9561 54.6663V55.6663V56.6663C59.1652 56.6663 60.9561 54.8754 60.9561 52.6663H59.9561ZM59.9561 24H60.9561C60.9561 21.7909 59.1652 20 56.9561 20V21V22C58.0607 22 58.9561 22.8954 58.9561 24H59.9561ZM45.2123 3H44.2123V36.3329H45.2123H46.2123V3H45.2123ZM43.2123 38.3329V37.3329H3V38.3329V39.3329H43.2123V38.3329ZM1 36.3329H2V3H1H0V36.3329H1ZM3 1V2H43.2123V1V0H3V1ZM1 3H2C2 2.44772 2.44772 2 3 2V1V0C1.34315 0 0 1.34315 0 3H1ZM3 38.3329V37.3329C2.44772 37.3329 2 36.8852 2 36.3329H1H0C0 37.9898 1.34315 39.3329 3 39.3329V38.3329ZM45.2123 36.3329H44.2123C44.2123 36.8852 43.7646 37.3329 43.2123 37.3329V38.3329V39.3329C44.8692 39.3329 46.2123 37.9898 46.2123 36.3329H45.2123ZM45.2123 3H46.2123C46.2123 1.34314 44.8692 0 43.2123 0V1V2C43.7646 2 44.2123 2.44772 44.2123 3H45.2123ZM20.6562 20L21.3599 19.2895L11.5985 9.62243L10.8948 10.333L10.1911 11.0435L19.9526 20.7105L20.6562 20Z"
          fill="currentColor"
        />
      </g>
    </SvgIconStyled>
  );
};
